import { createSelector } from '@ngrx/store';
import { latestTransactionsState } from '../root';

export const isDownloadingAnyTransaction = createSelector(latestTransactionsState, (latestTransactions) => latestTransactions.some((obj) => obj.isDownloading === true));
